import { GoogleTagManagerEvents } from "@faire/deprecated-retailer-visitor-shared/services/tracking/googleTagManagerEvents";
import { isE2E } from "@faire/web/common/user-agent/isE2E";

export const initializeGTM = () => {
  if (isE2E()) {
    return;
  }
  GoogleTagManagerEvents.get();
};
